/**
 * @author: ritesh.dabral
 * 
 * This page is responsbile for importing all atomic components and can help access 
 * everything inside this, with just one call
 */

// imports
import AtomSlickSliderArrows from "./AtomSlickSliderButton/AtomSlickSliderButton";

const AtomicComponent = {
    ...AtomSlickSliderArrows
}

export default AtomicComponent;

